<script setup>
import { ref, computed, toRaw } from 'vue';
import { useSubmit } from './submit-declaration';
import LifeInsuredDetails from './pages/LifeInsuredDetails.vue';
import ApplicationDeclaration from './pages/ApplicationDeclaration.vue';
import MedicalConsentAuthorityOnePath from './pages/MedicalConsentAuthorityOnePath.vue';
import MedicalConsentAuthorityTal from './pages/MedicalConsentAuthorityTal.vue';
import MedicalConsentAuthorityAia from './pages/MedicalConsentAuthorityAia.vue';
import PolicyAuthority from './pages/PolicyAuthority.vue';
import FinalDeclaration from './pages/FinalDeclaration.vue';
import MedicalConsentAuthorityZurich from './pages/MedicalConsentAuthorityZurich.vue';
import FormStepNav from './FormStepNav.vue';

const props = defineProps({
    insurer: {
        type: Object,
        required: true
    }
});

const { submit, loading, error, complete } = useSubmit();

const steps = [
    {
        label: 'Life Insured Details',
        handle: 'lifeInsuredDetails',
        component: LifeInsuredDetails,
        data: {}
    },
    {
        label: 'Application Declaration',
        handle: 'applicationDeclaration',
        component: ApplicationDeclaration,
        data: {}
    },
    {
        label: 'Policy Authority',
        handle: 'policyAuthority',
        component: PolicyAuthority,
        data: {}
    },
    {
        label: 'Medical Consent Authority',
        handle: 'medicalConsentAuthorityTal',
        component: MedicalConsentAuthorityTal,
        data: {}
    },
    {
        label: 'Medical Consent Authority',
        handle: 'medicalConsentAuthorityOnePath',
        component: MedicalConsentAuthorityOnePath,
        data: {}
    },
    {
        label: 'Medical Consent Authority',
        handle: 'medicalConsentAuthorityAia',
        component: MedicalConsentAuthorityAia,
        data: {}
    },
    {
        label: 'Life Insured Health Information Consent',
        handle: 'medicalConsentAuthorityZurich',
        component: MedicalConsentAuthorityZurich,
        data: {}
    },
    {
        label: 'Final Declaration',
        handle: 'finalDeclaration',
        component: FinalDeclaration,
        data: {}
    }
];

const stepCount = ref(0);

const currentStep = computed(() => {
    return insurerSteps.value[stepCount.value];
});

const insurerSteps = computed(() => {
    return steps.filter((step) => props.insurer.steps.includes(step.handle));
});

const advanceStep = (data) => {
    console.log('here');
    insurerSteps.value[stepCount.value].data = toRaw(data);
    if (stepCount.value < insurerSteps.value.length - 1) {
        stepCount.value++;
    } else {
        console.log(steps);
        submit(props.insurer.name, steps);
    }
};
</script>

<template>
    <div class="">
        <FormStepNav
            v-if="!complete"
            :steps="insurerSteps"
            :step-count="stepCount"
            @step="stepCount = $event"
        />
        <div class="tw-py-24 md:tw-pb-48 md:tw-pt-36 container container--narrow">
            <Transition name="slide" mode="out-in">
                <div v-if="complete">
                    <h2 class="panel-heading h2">Thank you</h2>
                    <h4 class="tw-text-center">You have successfuly submitted your declaration</h4>
                </div>
                <component
                    :is="currentStep.component"
                    v-else
                    :form-data="currentStep.data"
                    :insurer="props.insurer"
                    :steps="insurerSteps"
                    :loading="loading"
                    :error="error"
                    @advance-step="advanceStep"
                />
            </Transition>
        </div>
    </div>
</template>
